var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { utilTick } from "../../../utils/utilTick";
import { utilTime } from "../../../utils/utilTime";
export var HOCTimer = function (updateEveryFrame) { return function (TickableComponent) {
    return /** @class */ (function (_super) {
        __extends(Ticker, _super);
        function Ticker() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.tick = function () {
                _this.forceUpdate();
                var remainingTime = utilTime.secondsLeftTill(_this.props.remainingTime);
                if (remainingTime <= 0) {
                    _this.subscription.unsubscribe();
                }
            };
            _this.subscribe = function () {
                if (_this.subscription) {
                    _this.subscription.unsubscribe();
                }
                var stream$ = updateEveryFrame ? utilTick.frame$ : utilTick.second$;
                _this.subscription = stream$.subscribe(_this.tick);
            };
            return _this;
        }
        Ticker.prototype.componentDidMount = function () {
            this.subscribe();
        };
        Ticker.prototype.componentWillReceiveProps = function () {
            this.subscribe();
        };
        Ticker.prototype.componentWillUnmount = function () {
            if (this.subscription) {
                this.subscription.unsubscribe();
            }
        };
        Ticker.prototype.render = function () {
            return React.createElement(TickableComponent, __assign({}, this.props, this.state));
        };
        return Ticker;
    }(React.Component));
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/timer/HOCTimer.tsx
// module id = 353
// module chunks = 3